export const openUplift = 'Open Uplift'
export const openUpliftMachineExcluded = 'Open Uplift Machine Open Excluded'
export const incrementalOpen = 'Incremental Opens'
export const incrementalOpenMachineExcluded =
  'Incremental Opens Machine Opens Excluded'
export const colCount = 7
